"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var stylePacks_1 = require("./styles/stylePacks");
var i18next_1 = require("i18next");
var theme_1 = __importDefault(require("./styles/theme"));
var Icon_1 = __importDefault(require("./Icon"));
var Image_1 = __importDefault(require("./Image"));
var constants_1 = require("./Header2/constants");
// cannot use theme or components from UI,
// ErrorBoundary needs to be able to use at root, theme is not available outside of ThemeProvider
var Box = styled_1.default.div({
    boxSizing: 'border-box',
    margin: 0,
    padding: 0
});
var Title = (0, styled_1.default)(Box)((_a = {
        fontSize: '32px',
        fontWeight: theme_1.default.fontWeights.bold,
        lineHeight: '40px',
        letterSpacing: '0.02em',
        marginBottom: '40px'
    },
    _a[theme_1.default.mediaQueries.md] = {
        fontSize: '40px',
        lineHeight: '52px'
    },
    _a));
var Message = (0, styled_1.default)(Box)((_b = {
        fontSize: '18px',
        lineHeight: '28px',
        fontWeight: theme_1.default.fontWeights.regular,
        marginBottom: '20px'
    },
    _b[theme_1.default.mediaQueries.md] = {
        marginBottom: '30px',
    },
    _b));
var ErrorMessage = (0, styled_1.default)(Message)({
    color: theme_1.default.colors.error
});
var Link = (0, styled_1.default)(Box)(__assign(__assign({}, stylePacks_1.primaryButtonStyle), { borderColor: theme_1.default.colors.white, color: theme_1.default.colors.text, textDecoration: 'none', fontSize: '14px', lineHeight: '16px', height: 'auto', padding: '16px 75px', width: '100%', fontWeight: theme_1.default.fontWeights.medium, textAlign: 'center', backgroundColor: theme_1.default.colors.white, ':hover': {
        backgroundColor: theme_1.default.colors.primary,
        color: theme_1.default.colors.contrastText,
        borderColor: theme_1.default.colors.white
    } }));
Link.defaultProps = { as: 'a' };
var TopBar = (0, styled_1.default)(Box)((_c = {
        backgroundColor: theme_1.default.colors.white,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        height: constants_1.MOBILE_MENU_HEIGHT,
        paddingLeft: theme_1.default.space[3],
        paddingRight: theme_1.default.space[3]
    },
    _c[theme_1.default.mediaQueries.md] = {
        height: constants_1.MENU_HEIGHT,
        paddingLeft: theme_1.default.space[5],
        paddingRight: theme_1.default.space[5],
    },
    _c));
var TopBarApp = (0, styled_1.default)(TopBar)({
    backgroundColor: theme_1.default.colors.black,
    alignItems: 'end'
});
var FullLogo = (0, styled_1.default)(Box)((_d = {
        textDecoration: 'none',
        marginLeft: 'auto',
        display: 'none'
    },
    _d[theme_1.default.mediaQueries.lg] = {
        display: 'block'
    },
    _d));
FullLogo.defaultProps = { as: 'a' };
var Logo = (0, styled_1.default)(Box)((_e = {
        textDecoration: 'none',
        marginLeft: 'auto',
        display: 'block'
    },
    _e[theme_1.default.mediaQueries.lg] = {
        display: 'none'
    },
    _e));
Logo.defaultProps = { as: 'a' };
var Container = (0, styled_1.default)(Box)(function (_a) {
    var minHeight = _a.minHeight;
    return ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme_1.default.colors.black,
        minHeight: minHeight,
        fontFamily: theme_1.default.fonts.Roboto,
    });
});
var Content = (0, styled_1.default)(Box)((_f = {
        color: theme_1.default.colors.white,
        margin: 'auto',
        padding: '30px',
        width: '90vw'
    },
    _f[theme_1.default.mediaQueries.sm] = {
        maxWidth: '500px',
        padding: '60px'
    },
    _f[theme_1.default.mediaQueries.md] = {
        marginTop: 0,
        maxWidth: '700px',
        padding: '80px'
    },
    _f));
var ButtonContainer = (0, styled_1.default)(Box)({
    display: 'flex',
});
var TextContainer = (0, styled_1.default)(Box)((_g = {
        marginTop: '50px',
        marginBottom: '70px'
    },
    _g[theme_1.default.mediaQueries.md] = {
        marginBottom: '100px'
    },
    _g));
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hasError: false
        };
        return _this;
    }
    Object.defineProperty(ErrorBoundary, "getDerivedStateFromError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (_error) {
            // Update state so the next render will show the fallback UI.
            return { hasError: true };
        }
    });
    Object.defineProperty(ErrorBoundary.prototype, "componentDidCatch", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (error, errorInfo) {
            var _a, _b;
            (_b = (_a = this.props).onError) === null || _b === void 0 ? void 0 : _b.call(_a, error, errorInfo);
        }
    });
    Object.defineProperty(ErrorBoundary.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.state.hasError) {
                return this.props.children;
            }
            var _a = this.props, _b = _a.minHeight, minHeight = _b === void 0 ? '500px' : _b, title = _a.title, message = _a.message, buttonText = _a.buttonText, _c = _a.link, link = _c === void 0 ? '/' : _c, isAppH5 = _a.isAppH5, onCloseAppH5 = _a.onCloseAppH5;
            return (react_1.default.createElement(Container, { minHeight: minHeight },
                isAppH5 ?
                    react_1.default.createElement(TopBarApp, null,
                        react_1.default.createElement(Icon_1.default, { name: 'ff-icon-cross', fontSize: 5, color: 'white', onClick: onCloseAppH5 }))
                    :
                        react_1.default.createElement(TopBar, null,
                            react_1.default.createElement(FullLogo, { href: '/' },
                                react_1.default.createElement(Icon_1.default, { name: 'ff-icon-logo-full-black', fontSize: 5, color: 'black' })),
                            react_1.default.createElement(Logo, { href: '/' },
                                react_1.default.createElement(Icon_1.default, { name: 'ff-icon-logo', fontSize: { _: '23px', md: 5 }, color: 'black' }))),
                react_1.default.createElement(Content, null,
                    react_1.default.createElement(Image_1.default, { src: 'https://genesis-cdn.ff.com/assets/images/responsive/error-page-image-1600w.jpg', onError: function (event) { return event.currentTarget.style.display = 'none'; } }),
                    react_1.default.createElement(TextContainer, null,
                        react_1.default.createElement(Title, null,
                            title || (0, i18next_1.t)('Error title'),
                            "!"),
                        react_1.default.createElement(Message, null, (0, i18next_1.t)('Error contact sales')),
                        message && (react_1.default.createElement(ErrorMessage, null, message))),
                    react_1.default.createElement(ButtonContainer, null,
                        react_1.default.createElement(Link, { href: link }, buttonText || (0, i18next_1.t)('Error button name'))))));
        }
    });
    return ErrorBoundary;
}(react_1.default.Component));
exports.default = ErrorBoundary;
